/*
 * @Author: Chen Zhen
 * @LastEditors: Nie Wie
 * @Description: 时间轴
 * @Date: 2019-03-24 22:48:10
 * @LastEditTime: 2020-03-26 15:59:44
 */

/* eslint-disable no-underscore-dangle */

import zrender from 'zrender'
import _ from 'lodash'
import Position from './Position'

import { LINE_DEFAULT_COLOR } from './timeline.conf'

import {
  ArrowLeft,
  ArrowRight,
  ArrowTop,
  ArrowBottom,
  PlayButton,
} from './control'

import Item from './item'

// 默认配置
const DEFAULT_OPTION = {
  displayStyle: 'horizontal', // 横向  或者 ( vertical)  垂直
  itemStartIndex: 0, // 初始选中节点的位置
  control: {
    // 播放按钮
    play: {
      show: true,
      autoPlay: false,
      position: 'right',
      playInterval: 4000,
      defaultIndex: 0,
      handleClick: () => {},
      style: {
        size: 10,
      },
    },
    // 第一个按钮
    first: {
      style: {
        size: 10,
        arrow: Math.PI / 2,
      },
      handleClick: () => {},
    },
    // 第二个按钮
    second: {
      style: {
        size: 10,
        arrow: Math.PI / 2,
      },
      handleClick: () => {},
    },
  },
  middleHeight: null, // 可设置中间线--横向
  middleWidth: null, // 可设置中间线--纵向
  middleHeightOffset: 0, // 不偏移--上下
  middleWidthOffset: 0, // 不偏移--左右
  // 时间节点
  item: {
    handleChoose: null,
    style: {
      textFill: '#02EEFF',
      textAlign: 'center',
      fontFamily: 'Lato',
      fontSize: 13,
    },
  },
  lineStyle: {
    color: LINE_DEFAULT_COLOR,
  },
}

/**
 * 添加功能
 * 1. 构造函数 的默认 属性
 * 2. 设计传入参数
 * 3. 传入对应的属性参数
 * 4. 创建各个类
 * 5. 时间轴的 播放/停止
 * 6. 时间轴的自动播放动画
 * 7. 向外暴露的各个方法
 */
export default class Timeline {
  constructor(dom, opt) {
    // 进行类型判定
    if (!_.isElement(dom)) {
      throw new RangeError('new Timeline(dom: HTMLDivElement, opt?: Object)')
    }
    if (!_.isNil(opt) && !_.isObject(opt)) {
      throw new RangeError('new Timeline(dom: HTMLDivElement, opt?: Object)')
    }

    this._container = dom

    this._timeline = null // 对应的zrender容器

    this._position = null // 各个模块相关位置类

    this._firstButton = null

    this._secondButton = null

    this._playButton = null

    this._oldChooseItem = null

    this._placeholderSize = null

    this._data = null

    this.option = null

    this.items = []

    // this._index = 0

    this._chooseItem = null

    this._style = {
      width: 200,
      height: 60,
      middleHeight: 30,
    }

    /**
     * opt 为 创建容器对应的属性
     */
    this._initDom(opt)

    return this
  }

  get chooseItem() { return this._chooseItem }

  set chooseItem(chooseItem) {
    /*
    if (this._chooseItem !== null) this._chooseItem.isChoose = false
      this._chooseItem = chooseItem
      this._chooseItem.isChoose = true
    */
    if (this._chooseItem === null) {
      this._chooseItem = chooseItem
      this._chooseItem.isChoose = true
    } else if (this._chooseItem !== null && chooseItem.itemData.value !== null) {
      this.items.forEach((item) => {
        item.isChoose = false
      })
      this._chooseItem = chooseItem
      this._chooseItem.isChoose = true
    } else if (this._chooseItem !== null && chooseItem.itemData.value === null) {
      this._chooseItem = chooseItem
    }
    if (_.isFunction(this.option.item.handleChoose)) this.option.item.handleChoose(this._chooseItem.itemData, this._chooseItem.index)
  }

  // get index() { return this._index }
  // set index(index) {
  //   this._index = index

  //   // 选中独赢的点
  //   let item = this.items[index]
  //   if (item instanceof Item) {
  //     item.choose()
  //   } else {
  //     throw new Error('set index Error')
  //   }
  // }

  /**
   * 初始化创建容器
   */
  _initDom() {
    this._timeline = zrender.init(this._container)

    this._style.width = this._timeline.getWidth()
    this._style.height = this._timeline.getHeight()
    this._style.middleHeight = this._style.height / 2
    this._style.middleWidth = this._style.width / 2
  }

  /**
   * 初始化
   */
  init(data, opt = {}) {
    const _opt = _.defaultsDeep(opt, DEFAULT_OPTION)
    this.option = _opt

    this._placeholderSize = this.option.placeholderSize

    // TODO 改为中间线的偏移属性
    this._style.middleHeight = this.option.middleHeight || this._style.middleHeight
    this._style.middleWidth = this.option.middleWidth || this._style.middleWidth
    // 进行横向偏移操作
    if (_.isNumber(this.option.middleHeightOffset)) this._style.middleHeight += this.option.middleHeightOffset
    // 进行纵向偏移操作
    if (_.isNumber(this.option.middleWidthOffset)) this._style.middleWidth += this.option.middleWidthOffset
    // 根据opt.play 进行生成相关位置信息
    this._position = new Position(_opt, this._style)
    // 创建按钮
    if (_opt.displayStyle === 'horizontal') {
      // 横向的方式
      this._firstButton = new ArrowLeft({
        size: _opt.control.first.style.size,
        arrow: _opt.control.first.style.arrow,
        position: this._position.leftPosition,
        placeholderSize: this._placeholderSize,
        handleClick: this._handleClickOneButton,
      })
      this._timeline.add(this._firstButton.zrender)

      this._secondButton = new ArrowRight({
        size: _opt.control.second.style.size,
        arrow: _opt.control.second.style.arrow,
        position: this._position.rightPosition,
        placeholderSize: this._placeholderSize,
        handleClick: this._handleClickSecondButton,
      })
      this._timeline.add(this._secondButton.zrender)
    } else if (_opt.displayStyle === 'vertical') {
      // 垂直的方式
      this._firstButton = new ArrowTop({
        size: _opt.control.first.style.size,
        arrow: _opt.control.first.style.arrow,
        position: this._position.topPosition,
        placeholderSize: this._placeholderSize,
        handleClick: this._handleClickOneButton,
      })
      this._timeline.add(this._firstButton.zrender)

      this._secondButton = new ArrowBottom({
        size: _opt.control.second.style.size,
        arrow: _opt.control.second.style.arrow,
        position: this._position.bottomPosition,
        placeholderSize: this._placeholderSize,
        handleClick: this._handleClickSecondButton,
      })
      this._timeline.add(this._secondButton.zrender)
    }

    if (_opt.control.play.show) {
      this._playButton = new PlayButton({
        size: _opt.control.play.style.size,
        position: this._position.playPosition,
        status: _opt.control.play.autoPlay ? 'play' : 'stop',
        placeholderSize: this._placeholderSize,
        handleClick: this._handleClickPlayButton,
      })

      this._timeline.add(this._playButton.zrender)
    }

    // 创建中间的线
    const linePosition = [ this._position.linePosition1, this._position.linePosition2 ]

    const line = new zrender.Line({
      style: {
        stroke: this.option.lineStyle.color,
        lineWidth: 2,

      },
      shape: {
        x1: linePosition[0][0],
        y1: linePosition[0][1],
        x2: linePosition[1][0],
        y2: linePosition[1][1],
      },
    })
    this._timeline.add(line)

    // 根据data 设置对应的位置信息
    this._data = data

    // eslint-disable-next-line no-shadow
    this._data.forEach((data, index) => {
      const position = this._position.getPointPositionByIndex(this._data.length, index)

      const item = new Item({
        position,
        index,
        data,
        style: this.option.item.style,
        size: this.option.item.size,
        placeholderSize: this._placeholderSize,
        handleChoose: (_item) => {
          this.chooseItem = _item
        },
      })

      this.items.push(item)
      this._timeline.add(item.zrender)
    })

    // 赋值 当前的index
    this.chooseItem = this.items[this.option.itemStartIndex]
  }

  // 第一个按钮事件
  _handleClickOneButton = () => {
    const { index } = this.chooseItem
    if (index === 0) {
      this.chooseItem = this.items[this._data.length - 1]
    } else {
      this.chooseItem = this.items[index - 1]
    }
  }

  // 第二个按钮事件
  _handleClickSecondButton = () => {
    const { index } = this.chooseItem
    if (index + 1 === this._data.length) {
      // eslint-disable-next-line prefer-destructuring
      this.chooseItem = this.items[0]
    } else {
      this.chooseItem = this.items[index + 1]
    }
  }

  // 轮播按钮
  _handleClickPlayButton = (status) => {
    this._playButton.changeStatus(status === 'play' ? 'stop' : 'play')

    if (status === 'play') {
      // 停止时间轮回
      this._stopInterval()
      this._playButton.changeStatus('stop')
    } else {
      // 开始时间轮回
      this._startInterval()
    }
  }

  /**
   * 开始定时任务
   */
  _startInterval = () => {
    this._setTimeout()
  }

  /**
   * 停止定时任务
   */
  _stopInterval =() => {
    clearTimeout(this.interval)

    this.interval = null
  }

  _setTimeout = () => {
    this.interval = setTimeout(() => {
      let { index } = this.chooseItem

      if (index + 1 === this._data.length) {
        index = 0
        // eslint-disable-next-line prefer-destructuring
        this.chooseItem = this.items[0]
      } else {
        this.chooseItem = this.items[index + 1]
      }

      this._setTimeout()
    }, this.option.control.play.playInterval)
  }

  // 外部传入参数时间节点值--修改时间节点
  resetChooseItem(value) {
    if (this._chooseItem.itemData.value !== value) {
      const chooseOne = this.items.find(({ itemData }) => itemData.value === value)
      if (chooseOne) this.chooseItem = chooseOne
    }
  }

  // 外部传入参数节点位置 --修改时间节点
  resetChooseItemIndex(newIndex) {
    if (this._chooseItem.index !== newIndex) {
      const chooseOne = this.items.find(({ index }) => index === newIndex)
      if (chooseOne) this.chooseItem = chooseOne
    }
  }
}
